export default __webpack_public_path__ + "static/media/reportform.b36df70a.pdf";